import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'

import { composePDP } from '../../../components/hocs/compose-pdp'
import {
  getDeliveryIndicatorConfig,
  getSpecifications,
  pathOverrideConfig,
} from '../../../configuration'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const { productType } = props.product
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()
  const specificationConfiguration = getSpecifications(productType)

  return (
    <Page
      {...props}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={specificationConfiguration}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage, pathOverrideConfig)
